import * as React from 'react';

import Icon from '../../../../icon';
import Typography from '../../../../typography';
import { getWideDrawer } from '../../../ref';
import {
	HeaderRoot,
	HeaderContentLayout,
	HeaderCloseLayout,
	CloseButton,
} from './styled';


type WideHeaderProps = {}

const WideHeader: React.SFC<WideHeaderProps> = ({ children }) => {
	const handleClose = React.useCallback(() => getWideDrawer().close(), []);

	return (
		<HeaderRoot>
			<HeaderContentLayout>
				{children}
			</HeaderContentLayout>
			<HeaderCloseLayout>
				<CloseButton onClick={handleClose}>
					<Icon type='clear' color='white' width={24} height={24} />
				</CloseButton>
			</HeaderCloseLayout>
		</HeaderRoot>
	);
}

WideHeader.displayName = 'WideHeader';
WideHeader.defaultProps = {};

type DefaultTitleProps = {}

const WideTitle: React.SFC<DefaultTitleProps> = ({ children }) => {
	return (
		<WideHeader>
			<Typography.Title>
				{children}
			</Typography.Title>
		</WideHeader>
	);
}

WideTitle.displayName = 'WideTitle';
WideTitle.defaultProps = {};

export {
	WideHeader,
	WideTitle,
}
